import React from "react"
import styled from "styled-components"
import { Link, graphql, navigate } from "gatsby"
import { Tag, Button, Typography } from "antd"
import Layout from "../components/Layout"
import SEO from "../components/SEO"
import { isLoggedIn } from "../auth.js"

const { Title, Text } = Typography

const MoviePage = ({ data }) => {
  if (typeof window !== "undefined") {
    if (!isLoggedIn()) {
      navigate("/login")
      return null
    }
  }

  const { title, poster, overview, genres } = data.movie

  return (
    <Layout>
      <SEO title={title} />
      <Inner>
        <PosterImage src={poster} />
        <Content>
          <div>
            <Title level={3}>{title}</Title>
            <Text type="secondary">{overview}</Text>
          </div>
          <Tags>
            {genres &&
              genres.map(x => (
                <StyledTag key={x} color="default">
                  {x}
                </StyledTag>
              ))}
          </Tags>
        </Content>
      </Inner>
      <Link to="/">
        <StyledButtonBack type="link">Go back</StyledButtonBack>
      </Link>
    </Layout>
  )
}

export default MoviePage

export const query = graphql`
  query($id: String) {
    movie: moviesJson(id: { eq: $id }) {
      id
      title
      poster
      overview
      genres
    }
  }
`

const Inner = styled.div`
  margin: 24px 0;
  @media (min-width: 768px) {
    display: flex;
    max-width: 740px;
  }
`

const Content = styled.div`
  margin: 24px 0 0 0;
  @media (min-width: 768px) {
    margin: 0 0 0 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

const PosterImage = styled.img`
  width: 100px;
  @media (min-width: 768px) {
    width: 300px;
  }
`

const Tags = styled.div`
  margin: 24px 0 0;
`

const StyledTag = styled(Tag)`
  margin: 6px 6px 0 0;
`

const StyledButtonBack = styled(Button)`
  margin: 0 auto;
  display: block;
  @media (min-width: 768px) {
    margin: 0;
  }
`
